import React, { useState } from "react";
import { ImCross } from "react-icons/im";
import {
  initialFilterForm,
  searchInitialFilterForm,
  searchInputParams,
} from "./constant";
import SelectSearchInputParam from "../studentCharges/studentFiltersandwidget/SelectSearchInputParam";
import { styles } from "./constant";
import { ReactComponent as Search } from "assets/img/svg/SearchIcon.svg";

const SearchInput = ({
  searchInputValueHandler,
  onCancel,
  isLoading,
  globalFilter,
  setGlobalFilter,
}) => {
  const selectedSearchFieldProperties =
    searchInputParams[globalFilter?.searchField];
  const searchInputValue = globalFilter?.[globalFilter?.searchField];

  const searchHandler = () => {
    searchInputValue && searchInputValueHandler();
  };

  const onChangeHandler = (value) => {
    setGlobalFilter((prev) => ({ ...prev, [prev?.searchField]: value }));
  };

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      searchHandler();
    }
  };

  const handlePaste = (e) => {
    let pastedText = e.clipboardData?.getData("text/plain");
    setGlobalFilter((prev) => ({ ...prev, [prev?.searchField]: pastedText }));
    e.preventDefault();
  };

  const clickHandler = () => {
    searchInputValue && searchInputValueHandler();
  };

  return (
    <div
      className="d-flex flex-column"
      style={{ pointerEvents: isLoading ? "none" : "all" }}
    >
      <div style={{ position: "relative", minHeight: "35px" }}>
        <styles.StyledInput
          className="search-input"
          id="inputValue"
          value={searchInputValue}
          placeholder={selectedSearchFieldProperties?.placeholder}
          onChange={(e) => {
            onChangeHandler(e.target.value);
          }}
          onKeyDown={onKeyDownHandler}
          onPaste={handlePaste}
          searchInputValue={searchInputValue}
          selectedSearchFieldProperties={selectedSearchFieldProperties}
        />

        {searchInputValue && (
          <ImCross
            onClick={() => {
              onCancel();
            }}
            style={styles.crossIconStyle}
          />
        )}

        <styles.SeachWrapper>
          <Search onClick={clickHandler} />
        </styles.SeachWrapper>
      </div>

      <div className="ml-auto">
        <SelectSearchInputParam
          searchInputParam={globalFilter?.searchField || "paymentMode"}
          setSearchInputParam={(value) => {
            setGlobalFilter((prev) => ({
              ...globalFilter,
              searchField: value ?? "paymentMode",
              ...searchInitialFilterForm,
            }));
          }}
          searchParamTitleMap={searchInputParams}
          styles={{ width: "245px" }}
        />
      </div>
    </div>
  );
};
export default SearchInput;
